import { useQuery } from '@tanstack/react-query'
import { useAlertService } from '@/shared/lib/useAlertService'
import { SERVICE_SESSION } from '@/modules/signup-page/types'
import { CheckinsService } from '@/shared/api/rest/services/checkins.service'
import { adaptCheckinList } from '@/shared/api/rest/checkins.adapters'

export type StaleCheckoutType = {
    _id: string
    checkedInDate: Date
    checkinCode: string
    child: {
        _id: string
        firstName: string
        middleName: string
        lastName: string
    }
    checkedInParentBy: {
        _id: string
        firstName: string
        lastName: string
        phoneNumber: string
        relationship: string
    } | null
    checkedInAlternativeContactBy: {
        _id: string
        firstName: string
        lastName: string
    } | null
}

type UseStaleCheckoutsParams = {
    branchId: string
    session: SERVICE_SESSION | string
}

export function useStaleCheckouts({ branchId, session }: UseStaleCheckoutsParams) {
    const alertService = useAlertService()

    const { isLoading, error, data, refetch } = useQuery({
        queryKey: ['stale-checkouts', branchId, session],
        enabled: !!branchId && !!session,
        queryFn: async () => {
            try {
                const raw = await CheckinsService.stale({ branchId, session })
                return adaptCheckinList(raw) as unknown as StaleCheckoutType[]
            } catch (err) {
                alertService.error(
                    err instanceof Error ? err.message : 'Failed to load stale checkouts'
                )
                return [] as StaleCheckoutType[]
            }
        }
    })

    return {
        loading: isLoading,
        error: error ?? undefined,
        data: data ?? [],
        refetch
    }
}
